import { useEffect, RefObject } from 'react';

type Handler = (event: MouseEvent | TouchEvent) => void;

/**
 * Hook para detectar clics fuera de un elemento.
 * Se utiliza una firma de tipo más flexible para evitar errores de varianza de tipos en TypeScript.
 */
export const useOnClickOutside = (
  ref: RefObject<HTMLElement | null>,
  handler: Handler
): void => {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      // Verificamos si la referencia actual existe y si el objetivo del evento NO está contenido en ella
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return;
      }
      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};